export default __webpack_public_path__ + "static/media/neoLogo.f23a7a38.png";